import { createSlice } from "@reduxjs/toolkit";

// initial state of slice
const initialState = {
    employeeLocations: [], // variable for holding employee locations from database
};



// slice declaration
const liveLocationTabSlice = createSlice({
    name: "liveLocation",
    initialState,
    reducers: {
        reset: (state) => initialState,
        setEmployeeLocations: (state, action) => {
            state.employeeLocations = action.payload;
        },
    }
});

export const { reset, setEmployeeLocations } = liveLocationTabSlice.actions;
export const selectEmployeeLocations = (state) => state.liveLocation.employeeLocations;
export const selectEmployeeLocationsById = (state, employeeId) => {
    return state.liveLocation?.employeeLocations?.find(locDoc => locDoc?.employeeId === employeeId) || null;
};
export default liveLocationTabSlice.reducer;